import { Component, h } from 'preact';

class ResultJumpForm extends Component {
  constructor() {
    super();

    this.state = { value: '' };

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    this.setState({ value: event.target.value });

    const el = document.getElementById(event.target.value);

    if (el) {
      const bounds = el.getBoundingClientRect();
      const jumper = document.getElementById('results__bar');
      window.scrollTo(
        0,
        window.scrollY + bounds.top - jumper.getBoundingClientRect().height
      );
    }
  }

  render({ choices }, { value }) {
    return (
      <div class="result-jump">
        <label for="jump-select">Jump to office </label>
        <select id="jump-select" value={value} onChange={this.handleChange}>
          <option value="">--</option>
          {choices.map(choice => (
            <option value={choice.value}>{choice.name}</option>
          ))}
        </select>
      </div>
    );
  }
}

export default ResultJumpForm;



// WEBPACK FOOTER //
// ./components/ResultJumpForm.js